
export default function Footer() {
  return (
    <footer
      role="contentinfo"
      aria-label="Site footer"
      className="bg-gradient-to-br from-gray-800 to-gray-900 text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400 text-center md:text-left">
            © 2026 <span itemProp="name">Charlie Peters</span> · Meta Ads Specialist
          </p>
          <nav aria-label="Footer navigation" className="flex items-center gap-6">
            <a href="#about" className="text-xs text-gray-500 hover:text-white transition-colors whitespace-nowrap">About</a>
            <a href="#package" className="text-xs text-gray-500 hover:text-white transition-colors whitespace-nowrap">Services</a>
            <a href="#contact" className="text-xs text-gray-500 hover:text-white transition-colors whitespace-nowrap">Contact</a>
            <a
              href="https://www.linkedin.com/in/charliegeorgepeters/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Charlie Peters on LinkedIn"
              className="text-gray-500 hover:text-white transition-colors"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-linkedin-box-fill text-lg" aria-hidden="true"></i>
              </div>
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
